const angular = require('angular');
const app = angular.module('learn-directives');

function staticFileLoader($q, $http) {
  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [];
    for (var i = 0; i < options.files.length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var mergedData = {};

        for (var i = 0; i < data.length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

app.directive('customCopyManager', ['Application', 'Authorization', 'CustomCopy','AvailableCopy', 'customCopy', 'i18n', '$translate', '$q', '$http', function (Application, Authorization, CustomCopy, AvailableCopy, customCopy, i18n, $translate, $q, $http) {
  return {
    restrict: "E",
    replace: true,
    scope: {},
    template: require('../../templates/directives/custom-copy-manager.html'),
    controller: ['$scope', '$filter', function ($scope, $filter) {
      
      var self = this;
      var companyCopy = customCopy;
      var availableCopy;
      
      self.company = Authorization.getAuthToken().company._id;
      self.languages = Application.languages.getAvailable();
      self.currentLanguage = i18n.translate.use();
      self.language = '';
      self.activeKey = '';

      self.selectedLanguageTable = {};
      self.staticFileLoader = staticFileLoader($q, $http);

      self.customCopyAsTable = function() {
        var copyForDisplay = [];
        var currentLanguageCopyList = companyCopy[self.currentLanguage];

        availableCopy.map(function(copySet) {
          var copyList = {};
          var companyCurrentCopy = '';
          
          if (currentLanguageCopyList) {
            var matchingCopyKeys = currentLanguageCopyList.filter(function (object) {
              return object.key === copySet.key;
            });
            
            if (matchingCopyKeys.length) {
              companyCurrentCopy = matchingCopyKeys[0].value;
            }
          }
          
          copyList.displayName = self.selectedLanguageTable[copySet.key];
          copyList.companyCopy = companyCurrentCopy;
          copyList.helpText = copySet.helpText;
          copyList.translationKey = copySet.key;
          copyForDisplay.push(copyList);
        })
        return copyForDisplay;
      };      
      
      self.currentPage = 1;
      self.numPerPage = 6;
      self.currentSelectedCopy = '';
      self.tableLength = 1;
      
      self.loading = {
        finishedLoading: false,
        getNumber: function (number) {
          return new Array(number);
        }
      }
      
      self.paginate = {
        getLastPage: function () {
          return Math.ceil(self.tableLength / self.numPerPage);
        },
        goToNextPage: function() {
          self.currentPage += 1;
        },
        goToPreviousPage: function() {
          self.currentPage -= 1;
        },
        onSearch: function() {
          self.currentPage = 1;
          var filteredTable = $filter('filter')(self.asTable, $scope.searchQueries);
          self.tableLength = filteredTable.length;
          self.lastPage = this.getLastPage();
        }
      }
      
      self.lastPage = self.paginate.getLastPage();
      
      self.editing = {
        saving: false,
        currentlyEditing: null,
        inEdit: function(copy) {
          return this.currentlyEditing && copy.translationKey === this.currentlyEditing.translationKey;
        },
        startEdit: function(copy) {
          self.currentSelectedCopy = copy.companyCopy;
          this.currentlyEditing = copy;
        },
        cancelEdit: function(copy) {
          copy.companyCopy = self.currentSelectedCopy;
          this.currentlyEditing = null;
        },
        saveCopy: function(copy) {
          if (copy.companyCopy !== '' && copy.companyCopy !== self.currentSelectedCopy) {
            var update = {
              key: copy.translationKey,
              value: copy.companyCopy,
              language: self.currentLanguage
            };
            CustomCopy.edit({subresource: self.company}, update);
          }
          this.currentlyEditing = null;
        },
        deleteCopy: function(copy) {
          var update = {key: copy.translationKey, language: self.currentLanguage};
          CustomCopy.remove({subresource: self.company}, update);
          copy.companyCopy = '';
          this.currentlyEditing = null;
        }
      }
      
      
      self.selectLanguage = function(item) {
        self.currentLanguage = item.value;
        self.language = item.name;
        self.asTable = self.customCopyAsTable();
      };

      self.staticFileLoader({
        prefix: './translations/',
        suffix: '.json',
        key: self.currentLanguage
      }).then(translationData => {
        self.selectedLanguageTable = translationData;
      }).then(function() {
        AvailableCopy.get().$promise
        .then(function(results) {
          availableCopy = results;
          self.asTable = self.customCopyAsTable();
          self.tableLength = self.asTable.length;
          self.lastPage = self.paginate.getLastPage();
          self.loading.finishedLoading = true;
        })
      });

    }],
    controllerAs: 'customCopyManager'
  }
}])